import styled from 'styled-components';
import Dashboard from '../../../../../helpers/Dashboard';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  justify-content: space-between;
  gap: 1rem;
`;

export const Card = styled.div`
  background: #FFF;
  border-radius: 6px;
  border: 1px solid #EFF0F6;
  padding: 1rem;
  width: 100%;
  min-width: 11rem;
  min-height: 5rem;
  height: 100%;

  span {
    font-size: .9rem;
  }
  p {
    margin-top:1rem;
    font-size:1rem;
    font-weight: 500;
    color: #00000050;
    strong {
      color:#000;
      font-size:1.5rem;
    }
  }
`;